import { Position } from './position.model';

export class Lineup {
    formation: string;
    positions: Position[] = [];
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/lineup.model.ts